<template>
  <div>
    <div class="flex mx-1 my1">
      <template v-for="(metric, index) in GRAPH_METRICS">
        <metric
          :clickable="clickable"
          :key="metric.key"
          :metric="metric"
          :value="stats[metric.key]"
          :selected="value && value.includes(metric.key)"
          @select="$emit('input', [metric.key])"
        />

        <div
          v-if="index !== GRAPH_METRICS.length - 1"
          :key="metric.key + 'b'"
          class="metric_separator_vertical mb4 mt2"
        ></div>
      </template>
    </div>

    <hr class="my0 mxa" style="width: 92%"/>

    <div class="flex mx-1 mb2">
      <template v-for="(metric, index) in NON_GRAPH_METRICS">
        <metric
          :key="metric.key"
          :metric="metric"
          :value="stats[metric.key]"
        ></metric>

        <div
          v-if="index !== NON_GRAPH_METRICS.length - 1"
          :key="metric.key + 'b'"
          class="metric_separator_vertical mt1"
        ></div>
      </template>
    </div>
  </div>
</template>

<script>
import Metric from './dashboard_data/Metric.vue';

export default {
  name: 'metrics',
  components: { Metric },
  data() {
    return {
      metrics: this.$CONSTANTS.metrics,
      GRAPH_METRICS: this.$CONSTANTS.metrics.filter(metric => metric.includeInGraph),
      NON_GRAPH_METRICS: this.$CONSTANTS.metrics.filter(metric => !metric.includeInGraph),
    };
  },

  props: { clickable: Boolean, value: Array, stats: Object },
};
</script>

<style lang="scss" scoped >
.metric_separator_vertical {
  border-right: solid $color_hr 1px;
  display: inline-block;
}

</style>
